import {useEffect} from 'react';

const useWindowEventListener = <E extends Event = Event>(type: string, listener: (event: E) => void) => {
    useEffect(() => {
        window.addEventListener(type, listener as EventListener);

        return () => window.removeEventListener(type, listener as EventListener);
    }, []);
};

export default useWindowEventListener;
